module.exports = __webpack_public_path__ + "img/spezialisierungen_960.5d174c4f.webp";